// Mock data for Sat Drywall Ltd website

export const testimonials = [
  {
    id: 1,
    name: "John Mitchell",
    company: "Mitchell Construction",
    rating: 5,
    text: "Sat Drywall Ltd has been our go-to contractor for commercial projects. Their attention to detail and professionalism is unmatched. Highly recommended!",
    project: "Commercial Office Complex"
  },
  {
    id: 2,
    name: "Sarah Thompson",
    company: "Homeowner",
    rating: 5,
    text: "We hired Sat Drywall for our home renovation. The team was punctual, clean, and delivered exceptional quality. Our walls look perfect!",
    project: "Residential Renovation"
  },
  {
    id: 3,
    name: "Mike Chen",
    company: "Chen Developments",
    rating: 5,
    text: "Outstanding insulation work on our new builds. The spray foam insulation has made a huge difference in energy efficiency. Will definitely work with them again.",
    project: "New Construction"
  },
  {
    id: 4,
    name: "Lisa Anderson",
    company: "Anderson Properties",
    rating: 5,
    text: "Professional, reliable, and excellent craftsmanship. Sat Drywall completed our multi-unit project on time and within budget.",
    project: "Multi-Family Units"
  }
];

export const services = [
  {
    id: 1,
    title: "Commercial Drywall",
    description: "Professional drywall installation and finishing for commercial spaces, offices, and retail buildings.",
    icon: "Building2"
  },
  {
    id: 2,
    title: "Residential Drywall",
    description: "Expert drywall services for homes, renovations, and new construction projects of any size.",
    icon: "Home"
  },
  {
    id: 3,
    title: "Mud Tape",
    description: "Precision taping and mudding services for seamless, smooth wall finishes that are ready for painting.",
    icon: "PaintBucket"
  },
  {
    id: 4,
    title: "Spray Foam Insulation",
    description: "High-performance spray foam insulation for maximum energy efficiency and air sealing.",
    icon: "Droplet"
  },
  {
    id: 5,
    title: "Insulation Services",
    description: "Comprehensive insulation solutions to improve comfort and reduce energy costs year-round.",
    icon: "Shield"
  },
  {
    id: 6,
    title: "Blow Insulation",
    description: "Efficient blown-in insulation for attics, walls, and hard-to-reach spaces.",
    icon: "Wind"
  }
];

export const stats = [
  {
    id: 1,
    value: "15+",
    label: "Years Experience"
  },
  {
    id: 2,
    value: "500+",
    label: "Projects Completed"
  },
  {
    id: 3,
    value: "100%",
    label: "Client Satisfaction"
  },
  {
    id: 4,
    value: "24/7",
    label: "Customer Support"
  }
];
